import { Select, SELECT_VARIANT_WITH_CHECKBOX } from 'mailup-web-components'
import { searchState, tagsState } from 'Pages/TasksList/recoil/state/search'

import { useIntl } from 'react-intl'
import { useRecoilState, useRecoilValue } from 'recoil'

export const InputTags = () => {
  const intl = useIntl()
  const options = useRecoilValue(tagsState)

  const [{ tagIds }, setSearchParams] = useRecoilState(searchState)

  const handleInputChange = (e) => {
    const val = e
    setSearchParams((prev) => ({
      ...prev,
      tagIds: val
    }))
  }

  return (
    <Select
      multiple
      variant={SELECT_VARIANT_WITH_CHECKBOX}
      options={options}
      placeholder={intl.formatMessage({ id: 'Load.TagSelector.lblSelectTags' })}
      onChange={handleInputChange}
      value={tagIds || []}
      data-mu-test='select--tags'
    />
  )
}
